import request from '../utils/api'

export function sendWelcomeMail(token) {
  return request({
    url: '/v0/mail/intro',
    method: 'post',
    data: { token },
  })
}
